import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks";
import useRelatedData from './useRelatedData'
import useStorefrontData from './useStorefrontData'

export default function Products({ openedSidebar }) {
    const {
        response: { products },
        loading
    } = useAppState()

    var { swatchData } = useRelatedData();
    const { storefrontData } = useStorefrontData();

    // Check if PLP contains multiple vendors
    const brands = products?.hits.map(product => product?.brand)
    const oneBrand = brands.every(brand => brand === brands[0])

    // if(typeof okeWidgetApi?.initAllWidgets === 'function') {
    //     okeWidgetApi.initAllWidgets();
    // }

    //console.log("swatchData", swatchData)
    // console.log("storefrontData", storefrontData)

    useEffect(() => {
        if(window.innerWidth < 1024){
            var timeoutId;

            var checkSlick = function (callback) {
                if (jQuery && jQuery().slick) {
                    callback();
                    timeoutId = null
                } else {
                    timeoutId = setTimeout(function () {
                        checkSlick(callback);
                    }, 250)
                }
            }
        
            checkSlick(function () {
                jQuery(".ns-product").each(function(){
                    jQuery(this).find(".ns-mobile-carousel").not(".slick-initialized").slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        slidesToScroll: 1
                    })

                    jQuery(this).find(".slick-slide > div").addClass("padding-aspect padding-aspect--5/7")
                        // var firstImageHeight = jQuery(this).find('.slick-slider img:first').height();
                        // var secondImageHeight = jQuery(this).find('.slick-slider img:last').height();
                    
                        // if(firstImageHeight != secondImageHeight) {
                        //     jQuery(this).find('.slick-slider').css('height', firstImageHeight + 'px!important');
                        // }

                })
            })
            return () => {
              if(timeoutId) {
                clearTimeout(timeoutId)
              }
            }
        }
    }, [products])


    return (
        <div class={`grid grid-cols-2 gap-x-4 gap-y-10 ${openedSidebar ? 'lg:grid-cols-3' : 'lg:grid-cols-4'} lg:gap-x-7 mb-16`} style={loading ? "opacity: 0.3;" : ""}>
            {products?.hits.map((hit, index) => {
                return <Product product={hit} oneBrand={oneBrand} key={hit.productId || index} swatchData={ swatchData } storefrontData={ storefrontData } />
            })}
        </div>
    )
}